export default __webpack_public_path__ + "static/media/how-to-create-bsc-wallet.4abc1d51.pdf";